<template>
  <div class="manager_dashboard" :class="{invisible: isPageInvisible}">
    <user-menu />
    <div class="wrapper">
      <manager-sidebar-menu :show_menu="true" :show_back_button="false" />
      <div class="content-wrapper" style="padding-left: 165px;">
        <div class="container-wrapper center">

          <flash-message autoHide variant="success"></flash-message>

          <div class="row company-info">   
            <div class="col-6">
              <h3 class="d-inline heading company-name" style="font-size: 28px; font-weight: normal;">{{accountItems.account_name}} </h3>
              <div class="info-bold">
              <span class="acc-info">{{ accountItems.account_address ? accountItems.account_address + ',' : '' }}</span>
              <span class="acc-info">{{ accountItems.account_city ? accountItems.account_city + ',' : '' }}</span>
              <span class="acc-info">{{ accountItems.account_state ? accountItems.account_state + ',' : '' }}</span>
              <span class="acc-info">{{ accountItems.account_zip ? accountItems.account_zip : '' }}</span>
              </div>
            </div>

            <div class="col-6 text-right pr-3 pr-xl-5">
              <div class="pl-2 d-inline info-bold"  style="margin-top: 2px;" v-if="accountItems.account_has_license == 1  && unlimited == false">
                {{ accountItems.account_has_license }} {{ unitType }} Available
              </div>
              <div class="pl-2 d-inline info-bold"  style="margin-top: 2px;" v-else-if="unlimited == false">
                {{ accountItems.account_has_license }} {{ unitType }}s Available
              </div>
              <div class="pl-2 d-inline" v-if="type != '' && unlimited == false">
                <button type="submit" class="btn btn-md ma-blue-btn" @click="openAddLicenseModal">Add {{ unitType }}</button>
              </div>
              <div class="pl-2 d-inline" v-if="isBillingAdmin == true && hasManagerFlag == false">
                <button type="submit" class="btn btn-md ma-blue-btn" @click="openBillingModal">Billing</button>
              </div>
              <div class="pl-2 d-inline"  v-if="isPrimaryAdmin == true && hasManagerFlag == false">
                <button type="submit" class="btn btn-md ma-blue-btn" @click="openBrandingModal">Settings</button>
              </div>
            </div>

             <div class="col-8"></div>
             <div class="col-4 text-right pr-3 pr-xl-5" >
                            
              </div>                   
          </div>

              <div class="row">
                 <div class="col-7 pr-3 pr-xl-5">



                   <div class="db-card rounded shadow mentee-panel-wrapper">
                           <div class="row">
                                <div class="col-5 db_name_block">
                                   <span class="title">My Mentees <span style="font-weight: bold;">({{ menteeCount }})</span></span>
                                </div>
                                <div class="col-4 panel-heading-bold text-center">
                                  &nbsp;
                                </div>
                                <div class="col-3 text-right" v-if="(accountItems.account_has_license > 0 || unlimited == true)">
                                  <button type="submit" class="btn btn-primary btn-sm dbAddBtn" @click="openAddMenteeModal()" style="text-decoration: none !important; font-size: 16px; padding-right: 0;">Add Mentee</button>
                                </div>
                                <div class="col-3 text-right" v-else>
                                  <button type="submit" class="btn btn-primary btn-sm dbAddBtn" @click="noLicenseModal()" style="text-decoration: none !important; font-size: 16px; padding-right: 0;">Add Mentee</button>
                                </div>
                           </div>
                     
                      <div style="clear: both;"></div>

                      <div class="col-12 mt-2 db-empty-card" v-if="menteesApprentices.length == 0">
                        <div v-if="IsUserManager()">
                          <h6 class="empty-content-title">No Mentees Found. Let's add one!</h6>
                          <button v-if="(accountItems.account_has_license > 0 || unlimited == true)" type="submit" class="btn btn-primary btn-sm dbAddBtn" @click="openAddMenteeModal()" style="text-decoration: none !important; font-size: 16px; padding-right: 0;">Add Mentee</button>
                          <button v-else type="submit" class="btn btn-primary btn-sm dbAddBtn" @click="noLicenseModal()" style="text-decoration: none !important; font-size: 16px; padding-right: 0;">Add Mentee</button>
                        </div>
                        <div v-else>
                          <h6 v-if="card_title == 'Mentees'" class="empty-content-title">No Mentee Assigned to You… Yet!</h6>
                          <h6 v-if="card_title == 'Apprentices'" class="empty-content-title">No Apprentice Assigned to You… Yet!</h6>
                        </div>
                      </div>
             
                      <div class="col-12 p-0">
                        <div class="mentor-row" v-for="(item, index) in menteesApprentices" :key="index">
                            <div class="row">
                                <div class="col-5 db_name_block" @click="openEditMenteeModal(item.id)" style="cursor: pointer;">
                                    <div class="db-mentee-name">{{item.first_name + ' ' + item.last_name}}</div>
                                    <div class="db-mentee-email">
                                      {{ item.email }}
                                    </div>
                                </div>
                                <div class="col-4"  v-if="item.inactiveFlag == 1">
                                  <div class="active-link" style="">{{ item.monthDisplay }}</div>  
                                  
                                </div>
                                <div class="col-4"  v-else>
                                  -
                                </div>
                                <div class="col-3 text-right" style="" v-if="item.inactiveFlag == 1" @click="inactiveLicense(item.id)">
                                  <div class="inactive-link" style="">Inactivate</div>  
                                </div>
                                <div class="col-3 renew-flag text-right" v-else-if="item.assignFlag == 1" @click="assignLicense(item.id)">
                                  Assign License
                                </div>

                                <div class="col-3 text-right" style="">
                                  &nbsp;
                                </div>
                            </div>
                        </div>
                      </div>  
                  </div>

                  <div class="db-card rounded shadow mentor-panel-wrapper">
                      <db-card-list
                      card_title="My Mentors"
                      btnName="Add Mentor"
                      btnLink="add-mentor"
                      btnType="edit"
                      isListType="mentor"
                      :count="mentorCount" 
                      :itemLength="mentorItems.length" 
                      :allItems="mentorItems"         
                      tab_name="mentors"
                      @openAddMentorModal="openAddMentorModal"
                      @openEditUserModal="openEditUserModal">
                       </db-card-list>
                    </div>

              </div>


              <div class="col-5 pl-4 pl-xl-4 pr-3 pr-xl-5">              

                    <div class="db-card rounded shadow mentee-panel-wrapper">
                      <db-card-list
                      card_title="My Managers"
                      btnName="Add Manager"
                      btnLink="add-manager"
                      btnType="edit"
                      isListType="manager"
                      :count="managerCount" 
                      :itemLength="managerItems.length" 
                      :allItems="managerItems"         
                      tab_name="managers"
                      @openAddMentorModal="openAddMentorModal"
                      @openEditUserModal="openEditUserModal">
                       </db-card-list>
                    </div>

                </div>
                    
              </div>
      
      <InactiveLicense
        :isModalVisible="isInactiveModalVisible"
        :menteeName="menteeName"
        :menteeId="menteeId"
        :reassign_license_duration="reassign_license_duration"
        ref="InactiveModal"
        @close="isInactiveModalVisible = false">
      </InactiveLicense>

      <AddLicense
        :isModalVisible="isAddLicenseModalVisible"
        ref="AddLicenseModal"
        :totalLicense = "accountItems.account_has_license" 
        @close="isAddLicenseModalVisible = false">
      </AddLicense>

      <ProcessPayment
        :isModalVisible="isProcessPaymentModalVisible"
        ref="ProcessPaymentModal"
        @close="isProcessPaymentModalVisible = false">
      </ProcessPayment>

      <ViewMultipleCompletedAssessment :isModalVisible="isModalVisible" @close="isModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>View Assessments</h3></div>
        <div slot="body">
          <div class="col-11 override-padding" style="display:block; padding-top: 20px; !important" v-for="(item1, index) in multipleCompletedAssessment" :key="index">
            <div class="col-7 p-0 float-left" style="padding-top: 30px !important;">
              <b>{{ item1.assessmentName}}</b>
            </div>
            <div class="col-5 p-0 float-right" style="padding-top: 20px !important; text-align: right;">
            <button class="btn btn-md ma-blue-btn" style="width: 150px; height: 35px;" @click="viewMentorAssessmenteportModal(item1.completedAssessmentAttemptId)">Select</button>
            </div>
          </div>
          <div style="clear: both; margin-bottom: 20px;"></div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </ViewMultipleCompletedAssessment>

      <ResendAssessment :isModalVisible="isResendAssessmentModalVisible" @close="isResendAssessmentModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>Resend Assessments</h3></div>
        <div slot="body">
          <div class="col-11 override-padding" style="display:block; padding-top: 20px; !important" v-for="(item1, index) in multipleResendAssessment" :key="index">
            <div class="col-7 p-0 float-left" style="padding-top: 30px !important;">
              <b>{{ item1.assessmentName}}</b>
            </div>
            <div class="col-5 p-0 float-right" style="padding-top: 20px !important; text-align: right;">
            <button class="btn btn-md ma-blue-btn" style="width: 150px; height: 35px;" @click="resendAssessmentFromModal(item1.sendMentorAssessmentId)">Select</button>
            </div>
          </div>
          <div style="clear: both; margin-bottom: 20px;"></div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </ResendAssessment>

      <ActivateModal :isModalVisible="isAddMentorModalVisible"   @close="isAddMentorModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Add Mentor</div>
        <div slot="body">
          <div style="font-weight: bold; font-size: 13px; color: #002F42;">Are you sure you want to add {{ selectedMentorName }} as a mentor?</div>
        </div>
        <div slot="footer" class="col-4 p-0">
            <button class="left col-12 btn btn-red" @click="addMentorAction()" style="border-radius: 0px;">Add Mentor</button>
        </div>
      </ActivateModal> 

      <AdminconsoleOverlaySidebar
              :isAdminOverlayVisible="isAdminOverlayVisible" 
              @close="closeSidebar"
              ref="admin_overlay_sidebar"               
              :modalFormToLoad="modalFormToLoad"
              :totalLicense = "accountItems.account_has_license"
     />

     <InactiveUser
        :isModalVisible="isInactiveUserModalVisible"
        :userName="userName"
        :userId="userId"
        :user="user"
        :inactivateUserDefaultAction="inactivateUserDefaultAction"
        ref="InactiveUserModal"
        @close="isInactiveUserModalVisible = false">
      </InactiveUser>

      <NoAffiliateModal
        :isNoAffiliateModalVisible="isNoAffiliateModalVisible"
        ref="NoAffiliateModal"
        @close="isNoAffiliateModalVisible = false">
      </NoAffiliateModal>

      <UpdatePrimaryManagerModal
        :isUpdatePrimaryManagerModalVisible="isUpdatePrimaryManagerModalVisible"
        ref="update_primary_modal"
        @close="closeUpdatePrimaryManagerModal"
      />

      <NoLicense
        :isModalVisible="isNoLicenseVisible"
        :type="type"
        :unitType="unitType"
        ref="NoLicense"
        @close="isNoLicenseVisible = false">
      </NoLicense>


      <Billing
        :isModalVisible="isBillingModalVisible"
        ref="BillingModal"
        @close="isBillingModalVisible = false">
      </Billing>

      <Branding
        :isModalVisible="isBrandingModalVisible"
        ref="BrandingModal"
        @close="isBrandingModalVisible = false">
      </Branding>

      <AssignLicense
        :isModalVisible="isAssignModalVisible"
        :license_account_id="license_account_id"
        :hasLicense="hasLicense"
        :assignModalTitle="assignModalTitle"
        :menteeName="menteeName"
        :menteeId="menteeId"
        :type="type"
        :unlimited="unlimited"
        :unitType="unitType"
        ref="AssignModal"
        @close="isAssignModalVisible = false">
      </AssignLicense>

    </div>
    </div>
  </div>
 </div>
</template>

<script>
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import NoLicense from './no_license_modal.vue';
import InactiveLicense from './inactive_license_modal.vue';
import InactiveUser from './inactive_user_modal.vue';
import AddLicense from './add_license.vue';
import AssignLicense from './assign_license_modal.vue';
import RenewLicense from './Renewsubscription.vue';
import ProcessPayment from './process_payment.vue';
import ViewMultipleCompletedAssessment from '../admin/create-tasklist-modal.vue';
import ResendAssessment from '../admin/create-tasklist-modal.vue';
import ActivateModal from '../shared/delete_modal_alert.vue';
import Avatar from 'vue-avatar';
import DbCardList from './db_card_list.vue';
import AdminconsoleOverlaySidebar from './adminconsole_overlay_sidebar.vue';
import ManagerSidebarMenu from '@/components/shared/manager_sidebar_menu.vue';
import NoAffiliateModal from './no_affiliate_modal.vue';
import UpdatePrimaryManagerModal from '@/components/manager/update_primary_manager_modal.vue';
import Billing from './subscription.vue';

import Branding from './branding_settings.vue';

export default {
    data: function () {
        return {
            loading: false,
            accountItems: [],
            menteesApprentices: [],
            pendingMentors: [],
            isAssignModalVisible: false,
            isRenewModalVisible: false,
            isInactiveModalVisible: false,
            isAddLicenseModalVisible: false,
            showOverlay: false,
            license_expire_date: '',
            license_account_id: '',
            hasLicense: '',
            assignModalTitle: 'Activate User',
            menteeName: '',
            menteeId: '',
            reassignLicenseFlag: 0,
            reassignLicenseOptions: [],
            reassign_license_duration: 0,
            orderItems: [],
            isModalVisible: false,
            isAdminOverlayVisible: false,
            selectedMentorId: '',
            selectedMentorName: '',
            multipleCompletedAssessment: [],
            isAddMentorModalVisible: false,
            isResendAssessmentModalVisible: false,
            multipleResendAssessment: [],
            success_message: '',
            dismissCountDown: 0,
            managerItems: [],           
            managerCount: '',
            mentorItems: [],           
            mentorCount: '',
            see_more_managers_text: 'See more',
            show_more_managers: false,
            lessManagerItems: [],
            isProcessPaymentModalVisible: false,
            menteeCount: '',
            modalFormToLoad: 'add_mentee',
            userId: '',
            userName: '',
            user: {},
            isInactiveUserModalVisible: false,
            inactivateUserDefaultAction: 'inactivate',
            isNoAffiliateModalVisible: false,
            isPageInvisible: false,
            isUpdatePrimaryManagerModalVisible: false,
            isNoLicenseVisible: false,
            isRenewLicenseModalVisible: false,
            renewFlag: 0,
            unitType: '',
            isBillingModalVisible: false,
            isBrandingModalVisible: false,
            type: '',
            isBrandingFlag: false,
            unlimited: false,
            hasManagerFlag: false,
        }
    },
    beforeCreate: function() {
      store.dispatch('active_tab', '');
   },
   computed: {
    isPrimaryAdmin() {
      if ((this.$store.state.roles.indexOf('ROLE_PRIMARY_ADMIN') > -1) && (this.isBrandingFlag == true)) {
        return true;
      } else {
        if ((this.$store.state.switch_admin_roles.indexOf('ROLE_PRIMARY_ADMIN') > -1) && (this.isBrandingFlag == true)) {
          return true;
        } else {
          return false;
        }
      }
    },
    isBillingAdmin(){
      if ((this.$store.state.roles.indexOf('ROLE_BILLING_ADMIN') > -1) || (this.$store.state.roles.indexOf('ROLE_PRIMARY_ADMIN') > -1)) {
        return true;
      } else {
        if ((this.$store.state.switch_admin_roles.indexOf('ROLE_BILLING_ADMIN') > -1) || (this.$store.state.switch_admin_roles.indexOf('ROLE_PRIMARY_ADMIN') > -1)) {
          return true;
        } else {
          return false;
        }
      }
    }

   },
   methods: {
    assignLicense: function(menteeId) {
      this.showOverlay = true;
      axios('/desktop/manager/check-account-license',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: menteeId, 
        }
      })
      .then(resp => {
        this.showOverlay = false;
        this.hasLicense = resp.data.has_active_license;
        if(this.hasLicense == 0) {
          this.assignModalTitle = 'No ' + this.unitType + ' Avaliable';
        }
        this.license_expire_date = resp.data.account_license_expire_date;
        this.isAssignModalVisible = true;
        this.license_account_id = resp.data.account_license_id;
        this.menteeName = resp.data.mentee_name;
        this.menteeId = menteeId;
      })
      .catch(() => {
      });

    },
    openBrandingModal() {
     this.isBrandingModalVisible = true;
     this.$refs.BrandingModal.loadInitialData();
    },
    openBillingModal() {
     this.isBillingModalVisible = true;
     this.$refs.BillingModal.loadInitialData();
    },
    openRenewLicenseModal() {
     this.isRenewLicenseModalVisible = true;
     this.$refs.RenewLicenseModal.loadInitialData();
    },
    closeLicenseModal() {
     this.isAddLicenseModalVisible = false;
    },
    noLicenseModal() {
      this.isNoLicenseVisible = true;
    },
    IsUserManager() {
      var roles = this.$store.state.roles;
      if(roles.indexOf('ROLE_ADMIN') > -1 && (this.$store.state.switch_flag && this.$store.state.switch_flag.toLowerCase() == 'manager'))
      {
        return true;
      } else {
        if (
          this.$store.state.switch_admin_roles && 
          this.$store.state.switch_admin_roles.indexOf("ROLE_ADMIN") > -1 && 
          (this.$store.state.switch_flag 
          && this.$store.state.switch_flag.toLowerCase() == 'manager')
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    openUpdatePrimaryManagerModal(item) {
      this.isUpdatePrimaryManagerModalVisible = true;
      this.$refs.update_primary_modal.setUserInfo(item);
      this.$refs.update_primary_modal.getAllAdmins(this.$store.state.user_accountid);
    },
    closeUpdatePrimaryManagerModal() {
      this.isUpdatePrimaryManagerModalVisible = false;
    },

    openAddMentorModal(type) {
      this.isAdminOverlayVisible = true;

      if (type == 'mentor') {
        this.modalFormToLoad = 'add_mentor';
      } else {
        this.modalFormToLoad = 'add_manager';
      }      
      this.$refs.admin_overlay_sidebar.setupForm(type);
    },
    openEditUserModal(type, id) {
      this.isAdminOverlayVisible = true;
      this.modalFormToLoad = 'edit_user';
      this.$refs.admin_overlay_sidebar.getEditUser(type, id);
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    resendAssessmentFromModal: function(val) {
      axios('/desktop/manager/resend-mentor-assessment-token',
      {
        method: 'POST',
        params: {
          send_montor_assessment_id: val, 
        }
      })
      .then(resp => {
          this.success_message = 'Email Sent to Mentor successfully.';
          this.dismissCountDown = 5;    
          this.isResendAssessmentModalVisible = false;
      })
      .catch(() => {
      });
    },
    resendMentorAssessmentAction: function(item) {
      axios('/desktop/manager/resend-mentor-assessment-token',
      {
        method: 'POST',
        params: {
          send_montor_assessment_id: item.sendMentorAssessmentId, 
        }
      })
      .then(resp => {
          this.success_message = 'Email Sent to Mentor successfully.';
          this.dismissCountDown = 5;        
      })
      .catch(() => {
      });
    },
    openResendAssessmentModal: function(res) {
      this.multipleResendAssessment = res;
      this.isResendAssessmentModalVisible = true;
    },
    addMentorAction: function() {
      axios('/desktop/manager/activate-pending-mentor',
      {
        method: 'POST',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentor_id: this.selectedMentorId, 
        }
      })
      .then(resp => {
        this.getPendingMentors();
        this.isAddMentorModalVisible = false;
      })
      .catch(() => {
      });
    },
    addMentor: function(item) {
      this.selectedMentorId = item.id;
      this.selectedMentorName = item.first_name + ' ' + item.last_name;
      this.isAddMentorModalVisible = true;
    },
    openViewAssessmentModal: function(mentorId) {
      this.selectedMentorId = mentorId;
      axios('/desktop/manager/mentor-completed-assessment-lists',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentor_id: this.selectedMentorId, 
        }
      })
      .then(resp => {
        this.isModalVisible = true;
        this.multipleCompletedAssessment = resp.data.completedAssessments;
      })
      .catch(() => {
      });

      
    },
    viewMentorAssessmenteportModal: function(assessmentAttemptId) {
      this.isModalVisible = false;
      let route = this.$router.resolve({path: '/assessment-report/' + assessmentAttemptId});
      window.open(route.href, '_blank');
    },
    viewMentorAssessmenteport: function(assessmentAttemptId) {
      let route = this.$router.resolve({path: '/assessment-report/' + assessmentAttemptId});
      window.open(route.href, '_blank');
    },
    inactiveLicense: function(menteeId) {
      this.showOverlay = true;
      axios('/desktop/manager/check-account-license',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: menteeId, 
        }
      })
      .then(resp => {
        this.showOverlay = false;
        this.menteeName = resp.data.mentee_name;
        this.isInactiveModalVisible = true;
        this.menteeId = menteeId;
        this.reassign_license_duration = resp.data.reassign_license_duration;
      })
      .catch(() => {
      });
    },
    inactivateUser: function(item) {
        this.userId = item.id;
        this.userName = item.first_name + ' ' + item.last_name;
        this.user = item;
        this.isInactiveUserModalVisible = true;
        this.inactivateUserDefaultAction = 'inactivate';
    },
    activateUser: function(id, name) {
        this.userId = id;
        this.userName = name;
        this.isInactiveUserModalVisible = true;
        this.inactivateUserDefaultAction = 'activate';
    },
    formatAddress(city, state) {
      var address = '';
      if (city) {
          address += city + ", ";
      }
      if (state) {
          address += state + ", ";
      }
      return address.slice(0, -2);
    },
    initialAvatar(firstname, lastname) {
      var initial = '';
      initial = firstname.charAt(0) + lastname.charAt(0);
      return initial.toUpperCase();
    },
    getMenteeLicense: function() {
      axios('/desktop/manager/manage-license',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        this.unlimited = resp.data.unlimited;
        this.isBrandingFlag = resp.data.isBrandingFlag;
        this.type = resp.data.type;
        this.renewFlag = resp.data.renewFlag;
        this.unitType = resp.data.unitType;
        this.accountItems = resp.data;
        this.menteeCount = resp.data.menteesApprentices.length;
        this.menteesApprentices = this.accountItems.menteesApprentices;
        this.hasManagerFlag = resp.data.hasManagerFlag;
        
      })
      .catch((error) => {
        this.isNoAffiliateModalVisible = true;
        this.isPageInvisible = true;
      });

    },

    getOrderItems: function() {
      axios('/desktop/manager-orders/' + this.$store.state.user_accountid,
      {
        method: 'GET',
      })
      .then(resp => {
        this.orderItems = resp.data.orderItems;
        
      })
      .catch(() => {
      });

    },

    getInvoicePdf(item) {
      let pdfEndPoint;
      pdfEndPoint = '/getOrderInvoicePdf';
      axios(pdfEndPoint,
        {
          method: 'POST',
          data: {
              "billing": {
                  "billing_name": item.billingName,
                  "billing_address": item.address,
                  "billing_address2": item.address2,
                  "billing_city": item.city,
                  "billing_country": item.countryCode,
                  "billing_phone": item.phoneNumber,
                  "billing_state": item.stateCode,
                  "billing_zip": item.zipCode,
                  "billing_primary_admin": item.billingPrimaryAdmin
              },
              "orderId": item.orderId
          }
        },
      )
      .then(response => {
        window.open(response.data.invoice_filepath, '_blank');
      })
      .catch(error => {
        console.log(error)
      });
    },
    openAddLicenseModal() {
     this.isAddLicenseModalVisible = true;
     this.$refs.AddLicenseModal.loadInitialData();
    },
    closeLicenseModal() {
     this.isAddLicenseModalVisible = false;
    },
    openProcessPaymentModal(orderId) {
     this.isProcessPaymentModalVisible = true;
     this.$refs.ProcessPaymentModal.loadInitialData(orderId);
    },
    getMenteeProfileLink(id) {
      router.push('/view-mentee-profile/' + id);
    },
    getManagerList() {
      axios('/desktop/v2/account/manager-mentor-list',
      {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        this.managerCount = resp.data.manager.length;
        this.managerItems = resp.data.manager;
        this.mentorCount = resp.data.mentor.length;
        this.mentorItems = resp.data.mentor;
      })
      .catch(() => {
      });

    },
    openAddMenteeModal() {
      this.modalFormToLoad = 'add_mentee';
      this.isAdminOverlayVisible = true;      
      this.$refs.admin_overlay_sidebar.preLoadFormData();
    },
    openEditMenteeModal(menteeId) {
      this.modalFormToLoad  = 'edit_mentee';
      this.isAdminOverlayVisible = true;
      this.$refs.admin_overlay_sidebar.preLoadEditFormData(menteeId);
    },
    closeSidebar() {
       this.isAdminOverlayVisible = false;            
       this.$refs.admin_overlay_sidebar.resetAddMentorForm();
       this.$refs.admin_overlay_sidebar.resetAddManagerForm();
       this.$refs.admin_overlay_sidebar.resetEditUserForm();
    },

   },
   created() {
      var roles = store.state.roles;
      if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
        this.admin = true;
      }
      this.getMenteeLicense();
      this.getOrderItems();     
      this.getManagerList();
      setTimeout(() => {
      if(this.$store.state.invoice_order_id > 0) {
        this.openProcessPaymentModal(this.$store.state.invoice_order_id);        this.$store.dispatch('invoice_due_order_id', '');
      }
      }, 1500);

   }, 

   components: {
    UserMenu,
    NoLicense,
    InactiveLicense,
    AddLicense,
    ProcessPayment,
    ViewMultipleCompletedAssessment,
    ActivateModal,
    ResendAssessment,
    Avatar,
    DbCardList,    
    AdminconsoleOverlaySidebar,
    ManagerSidebarMenu,
    InactiveUser,
    NoAffiliateModal,
    UpdatePrimaryManagerModal,
    RenewLicense,
    Billing,
    AssignLicense,
    Branding,
   },
}
</script>

<style scoped>
.mentor-container {AdminconsoleOverlaySidebar,
  margin: 0px auto;
  width: 100%;
  padding-top: 0px;
}
.db-card {
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.rounded {
  border-radius: 10px !important;
  padding: 20px; 
}
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.db-card .acc-info {
  font-size: 13px;
  font-weight: 600;
  margin-left: 10px;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
/* media query css start */
@media (min-width: 992px) {
  .db-row {
    margin-left: 1rem;
  }
}
.question_text, .question_text a, .question_text a:hover {
  font-size: 11px;
  color: #7D7D7D;
}
.view-certificate {
    text-align: right;
    padding: 10px 16px 3px 30px;
    font-size: 12px;
}
.view-certificate a, .view-certificate a:hover{ 
  color: #7D7D7D !important;
  text-decoration: none !important;
  font-weight: bold;
}
.circle {
  background-color: #A5A5A5;
  border-radius: 30px;
  text-align: center;
  width: 60px;
  height: 60px;
  margin-right: 5px;
  float: left;
}
.initials {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  position: relative;
  transform: translateY(22px);
  color: #FFF;
  display: inline-block;
  vertical-align: middle;
}
.db-card .db-mentee-name {
  font-size: 14px;
  word-break: break-word;
  margin-top: 9px;  
  text-transform: capitalize;
}
.db-card .db-mentee-email {
  word-break: break-word;
  margin-top: 0px; 
  font-size: 13px;  
}
.license-count {
  font-size: 14px;
  margin: 1px 0px 15px 0px;
  padding-left: 10px;
}
.renew-flag {
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: center;
  cursor: pointer;
}
.red-text {
  color: #FF0000;  
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: center;  
}
.red-expire-text {
  color: #FF0000;  
  font-size: 13px;
  line-height: 15px;
  margin-top: 20px;
  text-align: center;  
}
.green-text {
  color: #008000;
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: center;  
}
.grey-text {
  font-size: 13px;
  line-height: 15px;
  margin-top: 20px;  
  text-align: center;
}
.receipt-heading {
  float: left;
  font-weight: bold;
  font-size: 14px;
  text-decoration: underline;
}
.receipt-heading-1{
  width: 18%;
}
.receipt-heading-4 {
  width: 22%;
}
.receipt-heading-3 {
  width: 18%; 
}
.receipt-heading-6 {
  width: 12%; 
}
.receipt-heading-2 {
  width: 30%;
}
.receipt {
  font-weight: normal;
  text-decoration: none;
  float: left;
  font-size: 13px;
  padding-top: 8px;
}
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.dbAddBtn, .dbEditBtn{
  border: 0px solid #29A3E4;
  background: none;
  font-size: 14px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  text-decoration: underline !important;
  text-align: right;
}
.dbEditBtn {
  width: 50px;
  float: right;
  margin-top: 15px;
}
.dbAddBtn:active, .dbAddBtn:focus, .dbAddBtn:hover, .dbEditBtn:focus, .dbEditBtn:hover {
  background:none !important;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
}
.info-bold {
  font-weight: bold;
  font-size: 12px; 
}
.company-name {
  font-size: 20px;
  text-transform: capitalize;
}
.mentor-panel-wrapper {
  margin-top: 15px;
}
.mentee-panel-wrapper {
  margin-top: 25px;
}
.panel-heading-bold {
  font-weight: bold;
}
.mentor-row {
  border-bottom: 1px solid #dadce0;  
  padding: 0px 0px 7px 0px
}
.inactive-link {
  color: #FF0000;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: right;
  cursor: pointer;
}        
.active-link {
  color: #5FAB91;
  font-weight: normal;
  font-size: 13px;
  line-height: 15px;
  margin-top: 15px;
  text-align: left;
}        
.alert {
  width: 50%;
  margin: 10px auto;
}
.db-card .mentor-row:last-child  {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/admin_console.vue